<template>
  <div class="card-block">
    <h3 class="card-title" v-if="showTitle">
      {{ $t("menu.clientUsageHistory") }}
    </h3>
    <div class="row">
      <div class="col-md-12">
        <div class="p-t-15">
          <div class="row">
            <div class="col-xs-2 col-md-3">
              <div class="form-group">
                <month-list
                  v-bind:teamData="team"
                  v-model="currentMonth"
                  v-on:input="fetchUsages(currentMonth)">
                </month-list>
              </div>
            </div>
          </div>
        </div>
        <div class="table-hover table-responsive" v-if="teams.length > 0">
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="w-50"></th>
                <th class="w-200">{{ $t("clientUsageHistory.labels.team") }}</th>
                <th class="w-150">{{ $t("clientUsageHistory.labels.invoiceNumber") }}</th>
                <th class="w-100 usage-column">{{ $t("clientUsageHistory.labels.usage") }}</th>
                <th class="w-250">{{ $t("clientUsageHistory.labels.retailPrice") }}</th>
                <th class="w-250">{{ $t("clientUsageHistory.labels.netPrice") }}</th>
                <th class="w-100">{{ $t("manageClientTeam.labels.type") }}</th>
                <th class="w-100 text-xs-center">{{ $t("manageClientTeam.labels.reseller") }}</th>
                <!--th class="w-50">{{ $t("clientUsageHistory.labels.discount") }}</th>
                <th class="w-150">{{ $t("clientUsageHistory.labels.netPrice") }}</th-->
                <th class="hidden-sm-down w-100"></th>
                <th class="hidden-sm-down w-100"></th>
              </tr>
            </thead>
            <tbody class="table-section" v-for="(bill, billIndex) in teams">
              <tr class="parent" v-bind:class="{ active : step === billIndex, 'a-link' : bill.items.length > 0 }" v-on:click="showChild(billIndex)">
                <td class="w-50 text-xs-center">
                  <span v-if="bill.items.length">
                    <i class="icon md-chevron-up" v-if="step === billIndex"></i>
                    <i class="icon md-chevron-down" v-else></i>
                  </span>
                </td>
                <td class="w-200 font-weight-medium">
                  <router-link
                    v-bind:to="`/${$route.params.namespace}/admin/teams/${bill.client_team.namespace}/billings`"
                    alt="Manage billing" class="btn btn-link">{{bill.client_team.name}}
                  </router-link>
                </td>
                <td class="w-100 font-weight-medium">
                  {{bill.invoice_number ? bill.invoice_number : '-'}}
                </td>
                <td class="w-150 usage-column">-</td>
                <!--td>{{bill.total_cost * 1.25}} {{ $t("billing.currencies.thb") }}</td>
                <td>20%</td-->
                <td>-</td>
                <td>{{bill.human_total_cost}} {{ $t("billing.currencies.thb") }}</td>
                <td>
                    <span v-if="bill.client_team.pay_plan === 'postpaid'" class="red-600">{{ $t("payPlan.labels.postPaid") }}</span>
                    <span v-else>{{ $t("payPlan.labels.prePaid") }}</span>
                </td>
                <td class="text-xs-center">
                  <router-link
                    v-bind:to="`/${$route.params.namespace}/admin/teams/${bill.client_team.reseller.namespace}/billings`" class="btn btn-link" alt="Reseller" v-if="bill.client_team.has_reseller">{{bill.client_team.reseller.name}}
                  </router-link>
                  <span v-else class="text-center">-</span>
                </td>
                <td class="w-150 hidden-sm-down">
                  <a v-if="bill.invoice_url" :href="`${bill.invoice_url}`" class="btn btn-primary" download>
                    Invoice
                  </a>
                </td>
                <td class="w-100 hidden-sm-down">
                  <router-link v-bind:to="urlUsageReport(bill.month)" class="btn btn-primary" target="_blank" v-if="showReportDownload(bill.month)">{{ $t("clientUsageHistory.action.usageReport") }}</router-link>
                </td>
              </tr>
              <tr class="child bg-grey-100 grey-700" v-for="(item, itemIndex) in bill.items" v-show="step === billIndex" >
                <td class="w-50"></td>
                <td class="w-200">
                 {{item.description}}
                </td>
                <td class="w-100"></td>
                <td class="w-100 hidden-sm-down">
                  {{item.human_data_usage}}
                </td>
                <td class="w-150 hidden-sm-down">
                  {{item.human_retail_price}} {{ $t("billing.currencies.thb") }}
                </td>
                <td class="w-150 hidden-sm-down">
                  {{item.human_cost}} {{ $t("billing.currencies.thb") }}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="alert alert-primary alert-dismissible" v-else>
          There is no client usage history on this month.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
import MonthList from 'components/MonthList';

export default {
  props: {
    team: {
      type: Object,
    },
    showTitle: {
      type: Boolean,
    },
  },
  components: {
    MonthList,
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    baseURL: function() {
      return process.env.BASE_URL;
    },
    shortCurrentMonth: function () {
      return moment(this.currentMonth, ['MMMM YYYY', moment.ISO_8601]).format('YYYY-MM');
    },
    downLoadUrl: function() {
      if (this.team && this.currentUser) {
        if (this.$route.params.subnamespace) {
          const parentUrl = this.$route.params.namespace;
          const namespace = this.$route.params.subnamespace;

          let role;

          if (this.currentUser.team.is_superadmin) {
            role = 'admin';
          } else if (this.currentUser.team.is_reseller) {
            role = 'reseller';
          }

          return `/${parentUrl}/${role}/teams/${namespace}/usage-report`;
        } else {
          const namespace = this.$route.params.namespace;
          return `/${namespace}/usage-report`;
        }
      }
    },
  },
  created: function() {
    this.isLoading = true;

    this.$emit('loadChanged', true);
  },
  mounted: function() {
    if (this.team) {
      this.fetchUsages(this.currentMonth);
    }
  },
  data: function () {
    return {
      currentMonth: moment().startOf('months').format('MMMM YYYY'),
      teams: [],
      step: -1,
    };
  },
  methods: {
    fetchUsages: function(month) {
      this.isLoading = true;

      const namespace = this.team.namespace;

      if (!month) {
        month = moment(this.currentMonth, ['MMMM YYYY', moment.ISO_8601]).format('YYYY-MM');
      } else {
        month = moment(month, ['MMMM YYYY', moment.ISO_8601]).format('YYYY-MM');
      }

      let url;

      if (this.currentUser.team.is_superadmin && !this.$route.params.subnamespace) {
        url = `/api/admin/bills?month=${month}&namespace=${namespace}&sort=cost`;
      } else {
        url = `/api/teams/${namespace}/bills?month=${month}&sort=cost`;
      }

      axios.get(url)
        .then((response) => {
          this.teams = response.data;
          this.isLoading = false;

          this.$emit('loadChanged', false);
        })
        .catch(() => {
          this.isLoading = false;

          this.$emit('loadChanged', false);
        });
    },
    showChild: function (value) {
      if (this.step !== value) {
        this.step = value;
      } else {
        this.step = -1;
      }
    },
    showReportDownload: function(month) {
      if (this.isLoading) {
        return false;
      }

      const now = moment().startOf('months');
      const start = moment(month, ['MMMM YYYY', moment.ISO_8601]).startOf('months');
      const months = (now.diff(start, 'months'));

      if (months > 0) {
        return true;
      }

      return false;
    },
    urlUsageReport: function (month) {
      if (!month) {
        month = moment(this.currentMonth, ['MMMM YYYY', moment.ISO_8601]).format('YYYY-MM');
      } else {
        month = moment(month, ['MMMM YYYY', moment.ISO_8601]).format('YYYY-MM');
      }

      return `${this.downLoadUrl}?month=${month}`;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ClientUsageHistory.vue?595f433f